// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import { clearFix } from 'components/styles/helpers'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'

const Title = styled.p`
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
  font-weight: bold;

  &:not(:first-of-type) {
    margin-top: ${spacing.small}px;
  }
`
const TextContainer = styled.div`
  margin-top: ${spacing.small_3}px;
  ${clearFix()};
`
const Text = styled.pre`
  float: left;
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
  line-height: 1.454;
  white-space: pre-wrap;
`
const LinkTextWrapper = styled.p`
  float: right;
`

type PropTypes = {
  title: string,
  text: string,
  onClickChangeCreditCard?: Function,
}

export default function ReservationSidebarBlock(props: PropTypes) {
  return (
    <Fragment>
      <Title>{props.title}</Title>
      <TextContainer>
        <Text>{props.text}</Text>
        {props.onClickChangeCreditCard && (
          <LinkTextWrapper>
            <LinkText href="#" onClick={props.onClickChangeCreditCard}>
              <Icon
                className="fa fa-refresh"
                positionType="left"
                fontSizeSp={fontSize.small_3}
              />
              {i18n.t('page.shared.change')}
            </LinkText>
          </LinkTextWrapper>
        )}
      </TextContainer>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationSidebarBlock/index.jsx